module.exports = __webpack_public_path__ + "assets/img/blindBoxBuy.18cb7efb.png";